import * as React from 'react';
import { Flex } from '../../Flex';
import { Grid } from '../../Grid';
import type { ComparisonColumn, ComparisonRowDef } from '../types';
import { isEmptyColumn, getMobileGridProps } from '../utils/helpers';
import { CellContent } from './CellContent';
import { ComparisonRowLabel } from './ComparisonRowLabel';
import { cn } from '@/hen-ui/utils';

interface ComparisonRowMobileProps {
  row: ComparisonRowDef;
  slideItems: ComparisonColumn[];
  styleVersion: 'v1' | 'v2';
  showLabel?: boolean;
}

export const ComparisonRowMobile: React.FC<ComparisonRowMobileProps> = ({
  row,
  slideItems,
  styleVersion,
  showLabel = true,
}) => {
  return (
    <Flex
      direction='column'
      className={cn(
        'w-full',
        styleVersion === 'v1' && 'border-b border-neutral-200',
      )}
      gap='none'
    >
      <Flex
        className={cn(
          'py-2',
          styleVersion === 'v1' ? 'px-0' : 'px-3',
          styleVersion === 'v2' && 'bg-neutral-50',
          !showLabel && 'invisible',
        )}
        direction='column'
        aria-hidden={!showLabel || undefined}
      >
        <ComparisonRowLabel
          label={row.label}
          labelTooltip={showLabel ? row.labelTooltip : undefined}
          labelTooltipSide={row.labelTooltipSide}
          labelTooltipFormat={row.labelTooltipFormat}
          labelTooltipTrigger={row.labelTooltipTrigger}
          textVariant='b5'
          textColor='heading'
          textWeight={styleVersion === 'v1' ? 'regular' : 'bold'}
        />
      </Flex>
      <Grid {...getMobileGridProps(slideItems.length)}>
        {slideItems.map((column) => {
          return (
            <Flex
              key={`${column.id}-${row.key}`}
              className={cn('py-2', styleVersion === 'v1' ? 'px-0' : 'px-2')}
              direction='column'
              gap='xxs'
            >
              {!isEmptyColumn(column) && (
                <CellContent row={row} value={column.fields[row.key]} />
              )}
            </Flex>
          );
        })}
      </Grid>
    </Flex>
  );
};

ComparisonRowMobile.displayName = 'ComparisonRowMobile';
